export enum DealerTypes {
  Default = 'Default',
  BYO = 'BYO',
}

export const PenProtectionPlanSourceTypes = {
  PEN: 'pen',
  STATIC: 'static',
};